export const messages = {
  refreshButtonLabel: 'Refresh page',
  title: 'Oops! Something went wrong.',
  body: 'Click the link below to go back or refresh this page.',
  code: '500',
  authBackButtonLabel: 'Back to dashboard',
  unauthBackButtonLabel: 'Back to homepage',
} as const
